<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'


@Component({
  name: 'AdminAdminFleetList'
})

export default class AdminAdminFleetList extends AdminList<AloDbFleet> {  
 
  get itemTypeName() {
    return "AdminFleet"
  }

  // BLF037 — Maintenance > flottes : flottes autorisées pour leur enseigne seulement (RG-ACC-050).
  get items(): Array<AloDbFleet> {
    const search = this.filter?.search?.toLowerCase() ?? ''
    return this.$store.myGetters.allowedAdminFleets.filter(
      (g: AloDbFleet) => search.length == 0 || (g.searchString ?? '').toLowerCase().indexOf(search) > -1,
    )
  }

}
</script>